export const footerLinks = [
	{ href: "/politica-de-confidentialitate", text: "Politica De Confidentialitate" },
	{ href: "/termeni-si-conditii", text: "Termeni si conditii" },
	{ href: "/politica-cookies", text: "Politica de utilizare cookie-uri" },
	{ href: "/formular-retur", text: "Formular de Retur" },
	{ href: "/politica-de-retur", text: "Politica de Retur" },
];
export const aboutLinks = [
	{ href: "/contact", text: "Contact" },
	{ href: "/autentificare", text: "Autentificare" },
     { href: "https://anpc.ro/", text: "A.N.P.C." }, 
     { href: "https://anpc.ro/?ref=footer_3_6", text: "PROTECŢIA CONSUMATORILOR - A.N.P.C." }, 
     { href: "https://anpc.ro/ce-este-sal/?ref=footer_3_5", text: "PROTECŢIA CONSUMATORILOR - A.N.P.C. - SAL" },
];

export const paymentImages = [
     { src: "/images/stripe.svg", width: 100, height: 30, alt: "", href: 'https://stripe.com/' }, 
	{ src: "/anpc-sal.svg", width: 150, height: 50, alt: "", href:'https://reclamatiisal.anpc.ro/' },
	{ src: "/anpc-sol.svg", width: 150, height: 50, alt: "", href:'https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=RO'},
];
